import { createAsyncThunk } from '@reduxjs/toolkit';
import type { Jauge } from '@/types';
import api from '@/api/client';
import { parsePaginatedResponse } from '@/api/types';
import { setJauges, editJauge, removeJauge } from '../slices/jaugeSlice';
import { setToast } from '../slices/toastSlice';

const PAGE_SIZE = 10;

export const fetchJauges = createAsyncThunk<void, number | undefined>(
  'jauge/fetch',
  async (pageNo, { dispatch, rejectWithValue }) => {
    try {
      if (pageNo != null) {
        const { data } = await api.get('/citernes/jauges', {
          params: { pageNo, pageSize: PAGE_SIZE, sortBy: 'id' },
        });
        const { list, pageNum, totalPages } = parsePaginatedResponse<Jauge>(data);
        dispatch(setJauges({ data: list, pageNum, totalPages }));
      } else {
        const { data } = await api.get<{ data: Jauge[] }>('/citernes/jauges');
        dispatch(setJauges(Array.isArray(data?.data) ? data.data : []));
      }
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur chargement jauges';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const createJauge = createAsyncThunk<boolean, Partial<Jauge>, { rejectValue: string }>(
  'jauge/create',
  async (jauge, { dispatch, rejectWithValue }) => {
    try {
      await api.post('/citernes/jauges', jauge);
      await dispatch(fetchJauges(0));
      dispatch(setToast({ message: 'Jauge créée', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur création';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const updateJauge = createAsyncThunk<boolean, Jauge, { rejectValue: string }>(
  'jauge/update',
  async (jauge, { dispatch, rejectWithValue }) => {
    try {
      await api.put(`/citernes/jauges/${jauge.id}`, jauge);
      dispatch(editJauge(jauge));
      dispatch(setToast({ message: 'Jauge modifiée', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur modification';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);

export const deleteJauge = createAsyncThunk<boolean, Jauge, { rejectValue: string }>(
  'jauge/delete',
  async (jauge, { dispatch, rejectWithValue }) => {
    try {
      await api.delete(`/citernes/jauges/${jauge.id}`);
      dispatch(removeJauge(jauge));
      dispatch(fetchJauges(0));
      dispatch(setToast({ message: 'Jauge supprimée', severity: 'success' }));
      return true;
    } catch (err: unknown) {
      const message = err instanceof Error ? err.message : 'Erreur suppression';
      dispatch(setToast({ message, severity: 'error' }));
      return rejectWithValue(message);
    }
  }
);
